import React, {} from 'react'
import BasicInput from '../../../../components/InputField/BasicInput'
import Radio from '../../../../components/Radio/Radio'
import {NewTeamFieldBlock} from './NewTeamForm'
import NewTeamFormBlock from './NewTeamFormBlock'










const NewTeamFormOrgName = (props) => {
  const {error, isNewOrg, onChange, onTypeChange, orgName, placeholder} = props
  return (
    React.createElement(NewTeamFormBlock, null
      , React.createElement(Radio, {
        checked: isNewOrg,
        name: "isNewOrganization",
        value: "true",
        label: "a new organization:"  ,
        onChange: onTypeChange,}
      )
      , React.createElement(NewTeamFieldBlock, null
        , React.createElement(BasicInput, {
          disabled: !isNewOrg,
          error: error,
          name: "orgName",
          placeholder: placeholder,
          onChange: onChange,
          value: orgName,}
        )
      )
    )
  )
}

export default NewTeamFormOrgName
